module.exports = __webpack_public_path__ + "static/media/chinaMap.53603a0a.png";